var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 221.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #808efc;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.17,138.59c-2.11,0-3.83-1.71-3.83-3.83v-47.53c0-2.11,1.71-3.83,3.83-3.83s3.83,1.71,3.83,3.83v47.53c0,2.11-1.71,3.83-3.83,3.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.16,169.98c-2.79,0-5.05-2.26-5.05-5.05V57.07c0-2.79,2.26-5.05,5.05-5.05s5.05,2.26,5.05,5.05v107.86c0,2.79-2.26,5.05-5.05,5.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.31,204.81c-3.39,0-6.15-2.75-6.15-6.15V23.33c0-3.39,2.75-6.15,6.15-6.15s6.15,2.75,6.15,6.15v175.34c0,3.39-2.75,6.15-6.15,6.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193,221.99c-4.3,0-7.78-3.48-7.78-7.78V7.79c0-4.3,3.48-7.79,7.78-7.79s7.78,3.49,7.78,7.79v206.42c0,4.3-3.48,7.78-7.78,7.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.68,206.63c-4.9,0-8.88-3.98-8.88-8.88V24.23c0-4.9,3.98-8.88,8.88-8.88s8.88,3.98,8.88,8.88v173.52c0,4.9-3.98,8.88-8.88,8.88Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.82,173.94c0,23.22-17.89,43.19-41.09,44.21-23.47,1.04-43.03-16.43-44.85-39.18-.18-2.25-1.7-4.18-3.85-4.84C19.36,165.85,0,140.83,0,111.45c0-25.43,14.52-47.45,35.71-58.27,1.73-.89,2.93-2.62,3.08-4.57,1.92-24.84,22.48-44.45,47.72-44.81,27.32-.39,49.32,22.53,49.32,49.86v120.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ede1958fec7928ca35e035f0c10a07f5.svg";
export { ForwardRef as ReactComponent };